<form [formGroup]="formGroup">
    <div *ngIf="isLoadingInitialResults || (!isLoadingInitialResults && items.length > 0)" class="form-group sticky">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-icon [svgIcon]="'v2:fi-br-search'" matPrefix></mat-icon>
            <input type="text"
                   matInput
                   formControlName="filterTerm"
                   [placeholder]="'Search....'"
                   [attr.aria-label]="'Search'">
        </mat-form-field>
        <mat-slide-toggle formControlName="selectAll">
            <flex-spacer></flex-spacer>
            <span>{{ 'Select All' }}</span>
        </mat-slide-toggle>
        <lf-control-messages [control]="formGroup" [prefix]="'At least one selection'"></lf-control-messages>
    </div>

    <ng-container *ngIf="isLoadingInitialResults; else loadedList">
        <div *ngFor="let count of (3 | counter)" class="form-group">
            <mat-slide-toggle disabled><app-avatar-block isLoadingInitialData="true"></app-avatar-block></mat-slide-toggle>
        </div>
    </ng-container>

    <ng-template #loadedList>
        <ng-container *ngIf="filtered.length > 0; else noDataState">
            <ng-container formArrayName="data">
                <ng-container *ngFor="let item of items.controls; let index = index">
                    <div class="form-group"
                         [formGroupName]="index"
                         [hasAnimation]="itemsAnimated"
                         [class.hidden]="!item.get('visible').value"
                         animated
                         fadeFrom="bottom"
                         delayed="list">
                        <ng-container *ngIf="listGroups.groups && !formGroup.get('filterTerm').value && (index === 0 || items.controls[index - 1].get('group').value !== item.get('group').value)">
                            <label *ngIf="item.get('group').value as groupKey">{{ listGroups.groups[groupKey].label }}</label>
                        </ng-container>

                        <mat-slide-toggle *ngIf="item.get('item').value as item" formControlName="selected" color="primary" disableRipple>
                            <ng-container *ngTemplateOutlet="listItemRef; context: { item, index }"></ng-container>
                        </mat-slide-toggle>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #noDataState>
        <button-spacer size="lg"></button-spacer>
        <ng-template #emptyStateContent>
            <app-empty-state [searchTerm]="formGroup.get('filterTerm').value">
                <span emptyStateTitle>{{ 'No results to display' }}</span>
            </app-empty-state>
        </ng-template>

        <ng-container *ngIf="emptyStateRef; else emptyStateContent">
            <ng-content select="app-empty-state"></ng-content>
        </ng-container>
    </ng-template>
</form>
